import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Buildingai() {
  return (
    <section className="scale_future_ai p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="resp_order mt-4 mt-md-0"
          >
            <StaticImage
              src="../../images/services-usa/ai/building_ai.webp"
              alt="tekrevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={777}
              height={776}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose TekRevol for <span>AI Development Services</span>
            </h2>
            <p>
              While we are a reputable AI software development company in USA,
              we have a global footprint, a strong portfolio of high-end AI
              applications in the B2B ecosystem and world-class talent that is
              always motivated to lead the change campaign with ground-breaking
              technology stacks. When we say we have built and scaled 23
              AI-based corporations successfully – we are pinpointing the
              capabilities and mechanisms that have helped us achieve this
              number. Here is what we practically do at TekRevol’s technical
              production houses – all day, every day:
            </p>
            <ul>
              <li>
                We utilize the right tech stack for building AI and then train
                them on relevant datasets.
              </li>
              <li>
                We build clean code – so while your business data can be
                accessed remotely, it’s safe and secure.
              </li>
              <li>
                We prioritize safety, controls and compliance when building and
                deploying AI software – so you can rest assured about
                governance.
              </li>
              <li>
                We uphold the highest ethical standards – for the biggest chunk
                of your end users – and we do so because of our holistic AI
                development process.
              </li>
              <li>
                We are result-oriented – that’s why, AI solutions that we build
                in-house at TekRevol scale and recombine innovation for business
                productivity and performance.
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Buildingai;
